angular.module('comcast.common.communication').factory('SecurityRoleResourceFactory', ['$resource', 'EndPointService', 'NotificationInterceptor', function ($resource, ResourceEndPointService, NotificationInterceptor) {
  'use strict';

  return $resource(ResourceEndPointService.securityRoleEndPoint + '/:id', {
    id: '@id'
  }, {
    getAll: {
      method: 'GET',
      url: ResourceEndPointService.securityRoleEndPoint,
      isArray: true,
      interceptor: new NotificationInterceptor().setObject('security roles').setAction('Retrieving')
    },
    save: {
      method: 'POST',
      url: ResourceEndPointService.securityRoleEndPoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('security role').setAction('Saving')
    }
  });
}]);